import React from 'react';
/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

export const Goal10 = () => (
  <SVG
    width="50"
    height="50"
    viewBox="0 0 2250 2250"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path d="M2250,2250H0V0H2250Z" fill="#de1f6e" />
    <Path
      d="M547.52,409.52c0,38.21,1.8,76.53-.47,114.61-2.61,43.82-21.25,79.7-64,97.78-28.27,12-58,11.6-87.52,4.33s-50.33-25.55-63.71-52.51c-9.62-19.36-13.72-40.11-13.79-61.55q-.3-102.67,0-205.37a149.53,149.53,0,0,1,11.52-58.37c12.86-30.33,35-50,67.19-57.54a154.9,154.9,0,0,1,74.16.39c42.42,10.79,64.22,40.71,73.19,81.41a190.77,190.77,0,0,1,3.94,37.88c.53,33,.18,66,.18,98.94ZM402,409.5h-.25c0,31.74-.52,63.49.27,95.2a139.47,139.47,0,0,0,6,35.84c3.54,11.88,13.21,17.74,25.88,17.65,11.87-.08,21.43-6.2,25.08-18.78,3.22-11.12,5.48-22.94,5.57-34.47q.78-95.2,0-190.41c-.11-12.54-2.62-25.31-5.77-37.52s-12.3-17.54-25.6-17.51c-13.74,0-22.79,5.61-26.21,17.89-2.53,9.06-4.55,18.58-4.69,27.92C401.68,340,402,374.77,402,409.5Z"
      fill="#fff"
    />
    <Path
      d="M1126.29,1612.75H924.63c-10.21,0-10.38-.17-10.38-10.58q0-57.35,0-114.7c0-10,.22-10.21,10-10.21h404.82c9.67,0,10.18.51,10.18,10.21q0,57.72,0,115.45c0,9.17-.67,9.83-9.79,9.83Q1227.88,1612.77,1126.29,1612.75Z"
      fill="#fff"
    />
    <Path
      d="M1126.64,1211.75H1329c10,0,10.21.24,10.21,10q0,57.72,0,115.45c0,9.21-.59,9.79-9.79,9.79H923.89c-9.31,0-9.64-.32-9.64-9.78,0-38.73.14-77.46-.14-116.19-.05-7.12,2-9.46,9.37-9.43C991.2,1211.85,1058.92,1211.75,1126.64,1211.75Z"
      fill="#fff"
    />
    <Path
      d="M1509.73,1411.44q0-95.57,0-191.15a56.07,56.07,0,0,1,.09-6.74c.61-5.17,3.25-5.78,7.08-2.76a43.27,43.27,0,0,1,3.77,3.65L1711,1404.73c6.76,6.76,6.76,7.82.09,14.49q-95.67,95.68-191.41,191.3c-2,1.94-4.79,3-7.21,4.46-.9-2.88-2.59-5.76-2.59-8.64Q1509.63,1508.9,1509.73,1411.44Z"
      fill="#fff"
    />
    <Path
      d="M743.76,1411.51q0,96.75,0,193.49c0,2.25.72,5.07-.35,6.59s-4.08,2.49-6.08,2.27c-1.57-.18-2.9-2.53-4.32-3.95L542.62,1419.53c-6.87-6.87-6.85-8.07.17-15.1q95.19-95.19,190.45-190.32c2.09-2.09,5.15-3.21,7.76-4.79.92,3.15,2.63,6.29,2.64,9.44Q743.88,1315.14,743.76,1411.51Z"
      fill="#fff"
    />
    <Path
      d="M1126.16,1029q-96.72,0-193.45-.1c-2.9,0-5.8-1.51-8.71-2.31,1.53-2.65,2.57-5.79,4.66-7.88q95.31-95.57,190.81-190.94c6.54-6.53,8-6.5,14.61.08q95.18,95.17,190.26,190.42c2.23,2.24,3.28,5.66,4.88,8.53-3,.73-5.9,2.1-8.86,2.11Q1223.27,1029.09,1126.16,1029Z"
      fill="#fff"
    />
    <Path
      d="M1127.08,1795.25q96.7,0,193.43.1c2.91,0,5.81,1.48,8.71,2.27-1.5,2.64-2.52,5.79-4.59,7.87q-95.3,95.57-190.78,190.93c-6.64,6.63-7.72,6.61-14.48-.15q-95.43-95.41-190.78-190.93c-2.07-2.08-3.06-5.23-4.55-7.89,3-.73,5.9-2.1,8.85-2.11Q1030,1795.16,1127.08,1795.25Z"
      fill="#fff"
    />
    <Path
      d="M275.52,622.82H193.44V279l-62.69,22.53c0-20-.14-39.11.23-58.2,0-1.78,2.93-4.05,5-5.16,17.57-9.4,35.28-18.53,52.88-27.87,3.07-1.63,6.39-3.35,8.62-5.89,9.89-11.31,22.47-12.71,36.46-11.83,13.65.85,27.4.18,41.58.18Z"
      fill="#fff"
    />
    <Path
      d="M1024.65,623.21c2.37,2.76,4,6,6.66,7.53,9,5.3,9.07,12.38,5.29,20.76a70.91,70.91,0,0,0-2.42,7.59c-12.23-6.59-20.47-16.5-28.67-26.53-1.53-1.87-4.1-4.06-6.23-4.1-27.49-.51-45.73-11.05-47.19-48.55-1-25.42-.76-50.94.31-76.36,1.51-35.81,23.18-46.41,53.55-43.92,25.76,2.1,38.28,14.19,40.09,42.43s.73,56.87-.23,85.28C1045.3,602.37,1038.72,615.22,1024.65,623.21Zm-9-80.17c0-15,.36-29.95-.12-44.91-.34-10.84-5.84-16.05-15.56-16.35-9.87-.32-15.17,4.33-16.9,15.1a58.18,58.18,0,0,0-.51,9c0,25.22-.1,50.44.05,75.66a60.9,60.9,0,0,0,1.64,13.31c1.38,5.89,5.37,9.25,11.5,10.23,11.78,1.89,19.31-3.76,19.77-16.34C1016,573.5,1015.62,558.27,1015.62,543Z"
      fill="#fff"
    />
    <Path
      d="M748.84,356.92H718.2V191.53c19.18.78,38,.27,56.43,2.63,23.17,3,34.25,18,33.48,42.83-.46,14.89-2.09,29.67-17.28,38.32-1.21.69-1.29,4.83-.69,7,6.22,22.86,12.68,45.65,19.06,68.46.47,1.68.82,3.39,1.39,5.8H780.33c-5.54-21.14-11.17-42.57-16.77-64-2.8-10.68-2.77-10.68-14.72-9.94Zm-.27-94.06c10.52-.67,21.71,1.62,27.26-9.18s5.93-23.19-1.05-33.47c-6-8.88-16.59-6.7-26.21-6.87Z"
      fill="#fff"
    />
    <Path
      d="M906.46,357.26V192.2c21.25.65,42.44-2.23,63.19,3.27,16.48,4.37,25.56,16.43,26.1,32.77,1,30.4,1.2,60.9,0,91.28-.85,21-13.28,32.85-34.1,36.52a82.38,82.38,0,0,1-13.4,1.17C934.53,357.36,920.83,357.26,906.46,357.26Zm30.62-21.79c22.32,2.3,28.59-2.83,28.86-24.4.32-25.48.09-51,0-76.46a49,49,0,0,0-.77-7.43c-1.1-7.07-5.51-11.27-12.33-12.21-5.06-.7-10.29-.14-15.8-.14Z"
      fill="#fff"
    />
    <Path
      d="M1308.53,193.63c18.7,0,37-1.1,55,.3,19.69,1.52,32.4,13,33.52,33.13a753.68,753.68,0,0,1-.23,94.22c-1.6,23-16.12,33.91-39.12,35.63-3.48.26-7,.32-10.48.33-12.72,0-25.45,0-38.71,0Zm30,141.8c21.47,2.27,28.88-3.18,29.17-22,.37-24.43.18-48.88.07-73.32,0-4.7.29-9.88-1.52-14s-5.48-8.67-9.43-10.17c-5.44-2.07-11.91-1.46-18.29-2Z"
      fill="#fff"
    />
    <Path
      d="M829.4,549V461.7h24.41V625.76c-5.76,0-11.29.54-16.61-.27-2.13-.33-4.57-3.31-5.56-5.63-11.28-26.63-22.29-53.37-33.4-80.08a13.45,13.45,0,0,0-4.24-6V625.2H768.52V461.27c6,0,12.15-.53,18.16.3,2,.28,4.13,3.78,5.21,6.25,11.2,25.57,22.19,51.24,33.28,76.86.73,1.69,1.75,3.26,2.63,4.89Z"
      fill="#fff"
    />
    <Path
      d="M1062.53,461.23h24.68c5.41,0,4,4.09,4,7,.07,34,0,68,.07,102,0,5.24.29,10.49.7,15.71a38.22,38.22,0,0,0,1.54,8.07c2.19,7.29,7.57,11.19,15,11.16s13-4,14.62-11.54a101.18,101.18,0,0,0,2-20c.19-34.49.09-69,.09-103.46v-8.44h29.56v7.8c0,34.74.08,69.48-.07,104.22a103.62,103.62,0,0,1-1.65,19.37c-4.75,24.27-16.91,36.25-48.18,34.91-29.11-1.24-42.14-16-42.69-47.68-.67-38.48-.19-77-.18-115.46A28.75,28.75,0,0,1,1062.53,461.23Z"
      fill="#fff"
    />
    <Path
      d="M1013.25,192.43h28.12c.14,3,.39,5.88.4,8.75,0,35.74-.09,71.49.12,107.24a72,72,0,0,0,2.32,17.71c1.89,7.16,7.4,10.21,14.77,10.11,7.12-.09,12.23-3.28,13.9-10.18a81,81,0,0,0,2.49-18.42c.23-35.5.12-71,.12-106.49v-8.5h28.82a7.44,7.44,0,0,1,.85,2.2c-.29,40.72.45,81.49-1.25,122.16-1.56,37.57-43.35,56.57-74.53,35-12.29-8.5-16.23-21.75-16.48-35.37-.75-40.72-.42-81.47-.48-122.2C1012.42,194,1012.78,193.53,1013.25,192.43Z"
      fill="#fff"
    />
    <Path
      d="M1212.17,252.42H1182c0-7.94.2-15.58,0-23.21-.37-10.81-4.63-15.64-13.72-16.16-9.57-.56-15,3.94-16.68,14.27a93.14,93.14,0,0,0-1,14.17c-.1,22-.14,44,0,66a96.66,96.66,0,0,0,1.46,16.38c1.63,9.11,6.86,13.15,15.57,12.79,8.35-.34,13.61-5.23,14.16-14.38.53-8.66.12-17.38.12-26.55h29.74c.29,14.7.68,29-5.37,42.73-4,9-10.64,15.12-19.91,18a63.11,63.11,0,0,1-39.08-.09c-16.85-5.54-25.2-19-25.88-35.21-1.31-30.89-2-62,.17-92.79,1.82-25.18,16.18-40.84,54-37.29,22,2.06,32.71,13.71,35.15,35.93C1211.6,235.14,1211.68,243.38,1212.17,252.42Z"
      fill="#fff"
    />
    <Path
      d="M1261.36,625.75c-8.19,0-16.15.24-24.06-.22-1.51-.09-3.75-2.8-4.12-4.62-2.19-10.72-3.93-21.53-5.86-32.56h-28l-6.89,37h-28.56c11.17-54.93,22.24-109.35,33.38-164.12,9.53,0,18.52-.22,27.48.18,1.75.08,4.58,2.3,4.91,3.94q16.18,79.14,31.9,158.38A13.84,13.84,0,0,1,1261.36,625.75ZM1213.9,506.27l-1.49.16c-3.28,20.3-6.55,40.6-9.88,61.24H1224C1220.53,546.75,1217.22,526.51,1213.9,506.27Z"
      fill="#fff"
    />
    <Path
      d="M1637.13,572.17c.91,5.82,1.28,10.57,2.46,15.1a41,41,0,0,0,4.54,10.93c3.57,5.82,9.37,7.26,15.72,6s8.83-6.33,9.4-12.09c1-10.68-3-19.69-10.68-26.83-9.33-8.66-19.06-16.89-28.59-25.34s-16.37-18.43-18.19-31.68c-4.29-31.29,16.47-52.65,48-48.76,23,2.84,36.1,19.35,35,44.82L1670.4,509c-1.32-6.25-2.22-11.88-3.75-17.34-2-7.05-7.18-9.91-14.28-9.27s-11.41,5-12.4,11.9c-1.1,7.8.84,15.07,6.69,20.59,8.89,8.39,18.11,16.43,27.21,24.61,14,12.59,24.37,27,24.43,46.91.09,25.14-16.46,42.2-41.64,41.75-33.74-.59-43-21.68-45.24-46.83-.14-1.44,1.91-4.1,3.39-4.48C1622,575,1629.36,573.74,1637.13,572.17Z"
      fill="#fff"
    />
    <Path
      d="M873.42,461.66h68.41V482.5h-38v46.71h29.9v21.7H903.86V604.6h38.43v20.88H873.42Z"
      fill="#fff"
    />
    <Path
      d="M1565,604.85h38.24v20.3h-68.58V461.72H1603v20.79h-38.1v46.83h29.87V551H1565Z"
      fill="#fff"
    />
    <Path
      d="M825.41,192.65h68.46V214H855.72v47h30.16v20.89h-30v54.31h38.46v20.51h-68.9Z"
      fill="#fff"
    />
    <Path
      d="M1257.41,336.26h38.29v20.61h-68.5v-164h68.24v21.2h-38v46.73h29.77v21.26h-29.77Z"
      fill="#fff"
    />
    <Path d="M1449.45,625.46H1419.1V483.8h-26.78V461.64h83.31v22.09h-26.18Z" fill="#fff" />
    <Path d="M1273.17,461.66H1303V604.32h38.9v21h-68.77Z" fill="#fff" />
    <Path d="M1513.75,625.48h-28.58V461.72h28.58Z" fill="#fff" />
    <Path d="M1353.72,461.72H1383V625.17h-29.25Z" fill="#fff" />
    <Path d="M718.88,461.69h29.27V625.3H718.88Z" fill="#fff" />
  </SVG>
);
